// src/routes/index.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from '../components/layout/Layout';

// Pages publiques
import HomePage from '../pages/HomePage';
import AboutPage from '../pages/AboutPage';
import ServicesPage from '../pages/ServicesPage';
import ServiceDetailPage from '../pages/ServiceDetailPage';
import ProjectsPage from '../pages/ProjectsPage';
import ProjectDetailPage from '../pages/ProjectDetailPage';
import ProjectApplicationPage from '../pages/ProjectApplicationPage';
import SolutionsPage from '../pages/SolutionsPage';
import SolutionDetailPage from '../pages/SolutionDetailPage';
import BlogPage from '../pages/BlogPage';
import ArticleDetailPage from '../pages/ArticleDetailPage';
import EventsPage from '../pages/EventsPage';
import EventDetailPage from '../pages/EventDetailPage';
import FormationsPage from '../pages/FormationsPage';
import FormationDetailPage from '../pages/FormationDetailPage';
import GalleryPage from '../pages/GalleryPage';
import ContactPage from '../pages/ContactPage';
import JoinPage from '../pages/JoinPage';
import NotFoundPage from '../pages/NotFoundPage';
import CommunityPage from '../pages/CommunityPage';
import TeamPage from '../pages/TeamPage';
import TeamDetailPage from '../pages/TeamDetailPage';
import TestimonialsPage from '../pages/TestimonialsPage';
import Newsletter from '../pages/Newsletter';

const AppRoutes = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Layout />}>
          {/* Pages d'accueil et informations générales */}
          <Route index element={<HomePage />} />
          <Route path="about" element={<AboutPage />} />
          
          {/* Routes pour les services */}
          <Route path="services">
            <Route index element={<ServicesPage />} />
            <Route path=":serviceSlug" element={<ServiceDetailPage />} />
          </Route>
          
          {/* Routes pour les projets */}
          <Route path="projects">
            <Route index element={<ProjectsPage />} />
            <Route path=":projectSlug" element={<ProjectDetailPage />} />
            <Route path=":projectSlug/apply" element={<ProjectApplicationPage />} />
          </Route>
          
          {/* Routes pour les solutions */}
          <Route path="solutions">
            <Route index element={<SolutionsPage />} />
            <Route path=":solutionSlug" element={<SolutionDetailPage />} />
          </Route>
          
          {/* Routes pour le blog */}
          <Route path="blog">
            <Route index element={<BlogPage />} />
            <Route path=":articleSlug" element={<ArticleDetailPage />} />
            <Route path="category/:categorySlug" element={<BlogPage />} />
            <Route path="tag/:tagSlug" element={<BlogPage />} />
          </Route>
          
          {/* Routes pour les événements */}
          <Route path="events">
            <Route index element={<EventsPage />} />
            <Route path=":eventSlug" element={<EventDetailPage />} />
          </Route>
          
          {/* Routes pour les formations */}
          <Route path="formations">
            <Route index element={<FormationsPage />} />
            <Route path=":formationSlug" element={<FormationDetailPage />} />
          </Route>

          {/*routes pour la communaute*/}


          
          {/* Galerie */}
          <Route path="gallery" element={<GalleryPage />} />
          
          {/* Contact et rejoindre */}
          <Route path="contact" element={<ContactPage />} />
          <Route path="join" element={<JoinPage />} />
          
          {/* Gestion des URLs inconnues */}
          <Route path="*" element={<NotFoundPage />} />
          
          {/* Pages d'équipe */}
          <Route path="team">
            <Route index element={<TeamPage />} />
            <Route path=":memberSlug" element={<TeamDetailPage />} />
        </Route>
          {/* Témoignages */}
          <Route path="testimonials" element={<TestimonialsPage />} />
          
          {/* Newsletter */}
          <Route path="newsletter" element={<Newsletter />} /> 


          <Route path="newsletter" element={<Newsletter />} /> 

          <Route  path="community" element={<CommunityPage/>}/>

          
        </Route>


        

        
      </Routes>
    </Router>
  );
};

export default AppRoutes;